import React from 'react'
import ModalV4 from "../../../../app/ui/modal/v4/v4"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import Button, {ButtonType} from "../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new";
import GenericList from "../../../../core/gd-modules/generic-list/render/list";
import TeamProjectsGList from "./glist/projects-glist";
import ApiTeam from "../../../../core/gd/api/company/team";
import ProjectSessionCollection from "../../../../core/model2/project/collection";
import ProjectSession from "../../../../core/model2/project/project-session";

type Props = {
    params: {
        projects    : ProjectSession[]
        teamId      : ID
    }
}

export default class ModalDeleteTeam extends ModalV4 {

    public glist    : TeamProjectsGList

    constructor(props: Props) {
        super(props);

        this.glist      = new TeamProjectsGList()

        this.state      = {
            deleteTeamAndUsersBtnBusy   : false,
            deleteTeamOnlyBtnBusy       : false
        }

    }

    deleteTeamAndUsers = async ()=> {
        this.setState({deleteTeamAndUsersBtnBusy: true})

        await ApiTeam.delete(this.props.params.teamId, true, false).promise()

        gd.modal.hide()
    }

    deleteTeamOnly = async ()=> {
        this.setState({deleteTeamOnlyBtnBusy: true})

        await ApiTeam.delete(this.props.params.teamId, false, false).promise()

        gd.modal.hide()
    }

    closeModal = ()=> {
        gd.modal.hide()
    }

    render() {

        this.glist.data.collection = new ProjectSessionCollection(this.props.params.projects)
        this.glist.data.process()

        return (
            <div className="v4-container placement-middle ui5-iv w-650"
                 style={{height: 785}}
                 onClick={this.stopPropagation}>
                <div className="flex-columns-top-bottom h-100p">

                    <div className="flex-row-right-center">
                        <div className="i5-delete m-t-10 m-r-10" onClick={this.closeModal}/>
                    </div>

                    <div className="ui5-title-app-name p-l-25 p-r-25 m-b-15">Delete Users</div>

                        <div className="big-panel p-l-25 p-r-25 p-b-15 m-t-10">
                            <div className="ui5-plate plate-error flex-row-left-top p-l-15 p-r-15">
                                <div className="flex-row-left-top w-60">
                                    <div className="i5-emergency-solid ui5-color-red fs-32 m-t-4"></div>
                                </div>
                                <div className="m-l-15">
                                    <p>
                                        You are about to delete a team from the organization.
                                    </p>
                                    <p className="m-t-10">
                                        Some members of this team are assigned to active projects.
                                        Please choose how you want to proceed.
                                    </p>
                                </div>
                            </div>
                        </div>

                    <VScroll style={{height: "calc(100% - 350px)"}}>
                        <GenericList module={this.glist}/>
                    </VScroll>

                    <div className="modal-submit flex-row-center-top fl-gap-8">

                        <Button className   = "w-150"
                                label       = "Delete team only"
                                type        = {this.state.deleteTeamOnlyBtnBusy ? ButtonType.BUSY : ButtonType.PRIMARY_RED}
                                disabled    = {this.state.deleteTeamAndUsersBtnBusy}
                                onClick     = {this.deleteTeamOnly}/>

                        <Button className   = "m-r-15 w-200"
                                label       = "Delete team & Remove users"
                                type        = {this.state.deleteTeamAndUsersBtnBusy ? ButtonType.BUSY : ButtonType.SECONDARY_RED}
                                disabled    = {this.state.deleteTeamOnlyBtnBusy}
                                onClick     = {this.deleteTeamAndUsers}/>

                    </div>
                </div>
            </div>
        )
    }
}
